import i18n from "i18n";

type violationTypeAheadProps = {
  clearButton?: boolean;
  className: string;
  id: string;
  placeholder?: string;
  maxHeight?: string;
  emptyLabel?: string;
};
export const violationTypeAheadProps: violationTypeAheadProps = {
  clearButton: true,
  className: "basic-typeahead-single",
  id: "offenceType",
  placeholder: `${i18n.t("offenceTypeName")}*`,
  maxHeight: "200px",
  emptyLabel: i18n.t("notFoundSearch"),
};
export const decisionTypeAheadProps: violationTypeAheadProps = {
  clearButton: true,
  className: "basic-typeahead-single",
  id: "decisionType",
  placeholder: `${i18n.t("labelDescision")}`,
  maxHeight: "200px",
  emptyLabel: i18n.t("notFoundSearch"),
};
export const suggestionTypeAheadProps: violationTypeAheadProps = {
  clearButton: true,
  className: "basic-typeahead-single",
  id: "suggestionType",
  placeholder: `${i18n.t("labelSuggestion")}*`,
  maxHeight: "200px",
  emptyLabel: i18n.t("notFoundSearch"),
};
